import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../Store/pageSlice";
import { Link } from "react-router-dom";

const RentalAgreement = () => {
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();
  const isDarkMode = useSelector((store) => store.currentModeStatus.darkMode);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(setCurrentPage("rental-agreement"));
  }, [dispatch]);

  return (
    <div className={`${isDarkMode ? "darkGreyMode" : "lightGreyMode"} pt-5`}>
      <div className="container footer_adjust mt-3 terms">
        <div className="row">
          <div className="col-md-12 mt-3 terms-section">
            <h2 className="text-center mb-3 title text-decoration-underline">
              JOULEZ ELECTRIC VEHICLE RENTAL AGREEMENT
            </h2>
            <br />
            <p className="px-3">
              This EV Rental Agreement (this "<strong>Agreement</strong>") shall
              go into effect between Joulez, Inc. ("<strong>Joulez</strong>")
              and the undersigned renter ("<strong>Renter</strong>"). Joulez and
              Renter may each be individually referred to herein as a “Party”
              and collectively as the “Parties.”
            </p>
            <p className="px-3">
              <strong>WHEREAS</strong>, Joulez is the owner and/or manager of
              the Electric Vehicle (the “<strong>EV</strong>”); and
            </p>
            <p className="px-3">
              <strong>WHEREAS</strong>, Renter desires to rent the EV from
              Joulez subject to the contractual provisions set forth below and
              subject to the Joulez{" "}
              <Link className="fontColorCE1" to="/terms-and-conditions">
                Terms & Conditions
              </Link>{" "}
              (the “<strong>Terms</strong>”); and
            </p>
            <p className="px-3">
              <strong>NOW, THEREFORE</strong>, in consideration of the mutual
              promises contained here, the Parties hereby agree to the
              following:
            </p>
            <ol className="fontColorFCC">
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Condition</strong>
                  </u>
                  &nbsp;The EV’s mileage, condition and damages will be
                  documented by photos and/or video at the time of pickup and
                  upon return of EV. Joulez will make this available via text
                  and/or web link for verification of the Parties. The EV is to
                  be returned in the same condition it was provided to the guest
                  with only standard wear and tear that would be expected from
                  the length of the rental.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Rental:</strong>
                  </u>
                  &nbsp;Joulez hereby rents the EV to Renter subject to the
                  provisions set forth in this Agreement and the Terms. Joulez
                  shall at all times during the Rental Period retain ownership
                  and title to the EV. Renter shall not have any ownership
                  interest in the EV as a result of this Agreement. Renter is
                  not Joulez’s agent and has no authority to bind Joulez or
                  transfer Renter’s rights and obligations under this Agreement.
                  Renter shall immediately notify Joulez in the event the EV is
                  levied, has a lien attached or is threatened with lien and/or
                  seizure as a result of Renter’s action, inaction, possession,
                  or use of the EV. Renter shall indemnify and hold Joulez
                  harmless against any and all losses and/or damages caused by
                  such action or inaction.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Rates and Fees:</strong>
                  </u>
                  &nbsp;The estimated rental rate and fees (the “
                  <strong>Rental Fee</strong>”) owed to and payable to Joulez
                  are detailed on Renter’s account receipts available on{" "}
                  <a
                    className="fontColorCE1 "
                    href="https://www.drivejoulez.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    www.drivejoulez.com
                  </a>{" "}
                  website and/or on Joulez's Stripe account web portal (the “
                  <strong>Account</strong>”). All charges owed to and paid to
                  Joulez will be shared via e-mail and/or text receipt
                  automatically and can be resent electronically or printed in
                  physical form upon Renter’s request. We reserve the right to
                  place a security deposit hold against your credit card or
                  debit card not to exceed $1,000 or $500 depending on the class
                  of vehicle (the “<strong>Deposit Hold</strong>”).
                  Notwithstanding the foregoing, in the event Renter is in
                  possession of the EV past the Rental Period set forth in this
                  Agreement, Renter hereby authorizes Joulez to charge the
                  payment method(s) on file in Renter’s Account for the total
                  Rental Fee and any associated fees for the duration of such
                  extended Rental Period.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Late Return:</strong>
                  </u>
                  &nbsp;If an EV is returned more than 30 minutes past its
                  scheduled return time and no formal request for an extension
                  has been made, the EV will be considered a Late Return. The
                  fee for a late return is $12.50/hr up to 4 hours. After 4
                  hours, a full day will be charged plus a $50 Failure to
                  Request Extension Fee. If after 24 hours an EV is not returned
                  and no formal reservation extension has been requested, the EV
                  will be considered stolen and all recovery measures will be
                  taken to recover and repossess the EV. Renter will be liable
                  and financially responsible for all days the vehicle is in
                  their possession and a $50/Day Failure to Request Extension
                  Fee will be applicable for those days. This is separate and
                  apart from any Repossession Fees listed in section 5.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">
                      Recovery and Repossession Fee:
                    </strong>
                  </u>
                  &nbsp; If an EV is required to be recovered or repossessed for
                  any reason, a repossession fee of $1/mile from the origin of
                  the trip will be charged with a minimum fee of $150. Any third
                  party tow fees, tow lot fees, storage fees and all other third
                  party fees required to recover the EV will be passed along to
                  the Renter with a 10% processing fee. If an EV is more than
                  250 miles from its origin and requires a recovery and/or
                  repossession, Renter will be responsible for a Long Distance
                  Recovery Fee of $500.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">
                      Cancellations; No Shows.
                    </strong>
                  </u>
                  &nbsp;Renter may cancel the booking with the Owner at any time
                  up to 24 hours before the commencement of Rental Period
                  without incurring any charges. Renter shall be liable to pay
                  one (1) days’ Rental Fee for cancellations made within 24
                  hours before the commencement of the reserved Rental Period.
                  For reservations made within 24 hours of the commencement of
                  the Rental Period, Renter may cancel up to six (6) hours
                  prior, otherwise, shall be liable to pay the one (1) days’
                  Rental Fee. In the event Renter fails to pick up the EV upon
                  the start of the reserved Rental Period, Joulez will
                  automatically charge Renter a no-show fee equal to one (1)
                  days’ Rental Fee. Joulez will provide a full refund for any
                  cancellations made by Joulez within 24 hours from the
                  commencement of the Rental Period. Any refunds provided
                  hereunder shall be inclusive of insurance fees, trip extras,
                  taxes, and any other fees. A reservation is considered a No
                  Show if the vehicle is not picked up after 4 hours from the
                  reservation start time.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Excess Mileage:</strong>
                  </u>
                  &nbsp;Mileage included with your rental will be detailed on
                  your booking receipt by e-mail and also available on your
                  Account page. Any excess mileage will be due upon return of
                  the vehicle and may be billed against any Deposit Hold held
                  against your credit or debit card.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">
                      Tolls, EV Charging and Other Charges:
                    </strong>
                  </u>
                  <p>
                    &nbsp;(a) During the Rental Period, any tolls, congestion
                    charges, tickets, violations or other similar charges, and
                    EV Charging billed to Joulez will be
                    <u className="mx-1">automatically billed</u>directly to the
                    payment method(s) on file on your Account. This might be
                    applied to the Deposit Hold, in the event that the payment
                    method(s) on file decline. A summary and breakdown of each
                    charge will be sent over via email, your account profile
                    and/or text either at the conclusion of the rental period or
                    after one week of rental, whichever occurs first, and the
                    charges will be available for review on Renter's Account. In
                    some cases, EV Charging may be paid for directly by Renter
                    including home charging or third-party charges that allow
                    for a payment card or other payment to be done on the
                    physical charger. Note that Tesla's Supercharger charges are
                    normally charged directly to Joulez and billed to Renter
                    thereafter. Joulez will charge Renter a 20% administrative
                    fee for all Tolls congestion charges, tickets and violations
                    and EV Charging to cover the costs of processing payments.
                  </p>
                  <p>
                    &nbsp; (b) Renter shall be responsible for any parking
                    tickets, fines, violations, or other citations incurred in
                    relation to the EV during the Rental Period. Some of these
                    may be sent to Joulez for payment, which Joulez will pay and
                    recover from Renter by way of reimbursement. This will be
                    automatically charged to the payment method(s) on file.
                    Alternatively, Joulez may be required to provide Renter’s
                    details to the relevant authority or other third-party who
                    will contact the Renter directly.
                  </p>
                  <p>
                    &nbsp; (c) If a vehicle is returned with a battery % more
                    than 9% less than the battery charge level provided at the
                    beginning of the rental, there will be a recharge service
                    fee as follows:
                    <div className="px-4">
                      <div>$10 for a variance of 10-19%</div>
                      <div>$20 for a variance of 20-29%</div>
                      <div>$30 for a variance of 30-39%</div>
                      <div>$40 for a variance of 40-49%</div>
                      <div>$50 for a variance of 50-59%</div>
                      <div>$60 for a variance of 60-69%</div>
                      <div>$70 for a variance of 70-79%</div>
                      <div>$80 for a variance of 80-89%</div>
                      <div>$90 for a variance of 90-99%</div>
                    </div>
                  </p>
                  <p>
                    &nbsp; (d) <b>Chargeback Fees:</b> In the event that the
                    Renter initiates a chargeback with their credit card issuer
                    for charges deemed valid by the Company and covered under
                    the signed Rental Agreement (including, but not limited to,
                    rental charges, late fees, damage charges, traffic
                    violations, or other incurred costs), the Renter shall be
                    liable for any and all administrative fees or charges levied
                    against the Company by the credit card issuer, payment
                    processor, or acquiring bank as a result of the chargeback.
                  </p>
                  <p>
                    &nbsp; (e) <b>Dispute Fees:</b> Should the Renter dispute a
                    valid charge with a third-party payment platform or
                    financial institution, and such dispute results in fees
                    being assessed to the Company, the Renter will be
                    responsible for these dispute fees. This applies to all
                    charges legitimately incurred and documented under the terms
                    of the Rental Agreement.
                  </p>
                  <p>
                    &nbsp; (f) <b>Collection Fees:</b> If the Renter fails to
                    pay any amounts due to the Company under the Rental
                    Agreement, including but not limited to the primary rental
                    charges, as well as any subsequently incurred chargeback or
                    dispute fees, the Company reserves the right to engage a
                    third-party collection agency or take legal action to
                    recover the outstanding amounts. The Renter shall be
                    responsible for all costs associated with these collection
                    efforts, including but not limited to:
                  </p>
                  <ul>
                    <li>
                      Collection agency fees (which may be a percentage of the
                      outstanding debt)
                    </li>
                    <li>Reasonable attorney’s fees</li>
                    <li>Court costs</li>
                    <li>
                      Any other expenses incurred in the process of recovering
                      the debt
                    </li>
                  </ul>
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Scope of Use:</strong>
                  </u>
                  &nbsp;Renter shall use the EV only for personal,
                  non-commercial use, and will operate the EV only on properly
                  maintained roads and parking lots. Renter shall comply with
                  all applicable laws pertaining to operation of the EV during
                  the Rental Period, including, but not limited to maintaining a
                  valid license to operate a motor vehicle, and insurance.
                  Renter shall exercise ordinary care to avoid damage to the EV
                  and shall not use the EV in a way likely to result in damage
                  to Renter, the EV, to property, or to other persons.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">
                      Vehicle Use Restrictions:
                    </strong>
                  </u>
                  &nbsp;The following list includes common examples; however,
                  these examples are not intended to be a complete list of all
                  prohibited uses. Joulez reserves the right to add restrictions
                  as reasonably necessary to protect itself, its property,
                  others, or the property of others. Renter shall not:
                </p>
                <div className="mb-2">
                  <div>
                    (a) permit the EV to be operated by any person who is not
                    listed as a Renter under this Agreement
                  </div>
                  <div>
                    (b) operate the EV or permit it to be operated in violation
                    of law, including without limitation, driving under the
                    influence of alcohol or drugs, or in breach of any traffic
                    rules or regulations.{" "}
                  </div>
                  <div>
                    (c) operate the EV or permit it to be operated to commit any
                    violation of law.
                  </div>
                  <div>
                    (d) operate the EV or permit it to be operated for any race,
                    test, or contest.{" "}
                  </div>
                  <div>
                    (e) operate the EV or permit it to be operated for the
                    transport of more passengers or goods than the maximum
                    allowable for the EV.{" "}
                  </div>
                  <div>
                    (f) operate the EV or permit it to be operated to carry
                    hazardous materials or explosive substances of any kind.
                  </div>
                  <div>
                    (g) operate the Vehicle or permit the EV to be driven or
                    parked on roadways not regularly maintained, or on any
                    roads, beaches, driveways, or surfaces likely to cause
                    damage to the EV.{" "}
                  </div>
                  <div>
                    (h) operate the EV or permit the EV to be driven or parked
                    in unsafe areas or where the EV is likely to be damaged.
                  </div>
                  <div>
                    (i) operate the EV or permit the EV to be operated to push
                    or tow any other vehicle.{" "}
                  </div>
                  <div>
                    (j) tamper with, remove, or disable the EV’s the USB stick
                    during the rental period and while in possession of the EV.
                  </div>
                  <div>
                    (k) transport any animal in the EV (with the exception of
                    certified or licensed animals for assisting persons with
                    disabilities); and/or
                  </div>
                  <div>
                    (l) allow any person to smoke and/or take or use alcohol or
                    illegal drugs in the EV. In the event Renter engages any of
                    the above, Joulez reserves the right, in its sole
                    discretion, to temporarily or permanently ban Renter from
                    making any further bookings.
                  </div>
                </div>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">
                      Authorized Drivers:
                    </strong>{" "}
                  </u>
                  &nbsp;The persons who are authorized as a Renter to operate
                  the EV during the Rental Period are listed at the end of this
                  Agreement. All authorized Renter’s shall provide a valid
                  driver’s license upon execution of this Agreement. Renter
                  shall not rent or sublease the EV or allow any other person
                  not identified in this Agreement as an authorized operator to
                  operate the EV. A physical driver’s license is required to be
                  presented to a garage attendant or virtually as part of a
                  mobile phone selfie to a Joulez remote support assistant at
                  the start of every rental. No EV may exit the garage without
                  proof of a physical driver’s license.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Insurance:</strong>
                  </u>
                  &nbsp;Renter must provide Joulez with proof of insurance
                  sufficient to cover damage to the EV during the Rental Period,
                  as well as personal injury to the Renter, passengers in the
                  EV, other persons or property, its sufficiency to be
                  determined at Joulez’s sole discretion. If the EV is damaged
                  or destroyed while it is in possession of Renter, Renter
                  agrees to pay any required insurance deductible and assign all
                  rights to collect insurance proceeds to Joulez. Tesla and some
                  vehicles are set to a speed limit of 85 MPH and Chill Mode.
                  Renter’s must provide Joulez with a copy of their insurance
                  coverage in order to remove this limitation. Joulez also
                  provides Renter with the option of purchasing additional
                  coverage, at an additional cost, in connection with the EV
                  during the Rental Period.{" "}
                  <strong>
                    Please see available coverage options in <u>Exhibit A</u>.
                  </strong>{" "}
                  In the event Renter purchases any third party insurance
                  coverage, Renter shall be solely responsible from collecting
                  the claim from such third-party insurer as the policy holder
                  and shall indemnify Joulez pursuant to Section 23 hereunder.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Alterations:</strong>
                  </u>
                  &nbsp;Except for any minor repairs and maintenance that may be
                  required during the Rental Period, Renter shall make no
                  alterations whatsoever to the EV without the prior written
                  consent of Joulez. Unless otherwise agreed by Joulez, any such
                  approved alterations shall be the property of Joulez and
                  become part of the EV subject to this Agreement.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Personal Property:</strong>
                  </u>
                  &nbsp;Joulez is not responsible for loss, theft, or damage to
                  any of Renter’s personal property (or that of any other
                  passenger, driver, or occupant of the EV during the Rental
                  Period) in or on the EV or received by Joulez under any
                  circumstances. This includes if a vehicle is repossessed due
                  to non-payment, fraud, or any other financial dispute. Joulez
                  has the right to dispose of any such property left in the EV
                  in such manner as the Joulez may deem fit at the Renter’s
                  costs after three (3) days from the date on which the EV is
                  returned or repossessed without incurring any liability to
                  Renter. Notwithstanding the foregoing, Joulez may (but is not
                  obliged to) retain possession of any property found in the EV
                  pending settlement in full by Renter of any and all sums due
                  to Joulez.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">
                      Loss and Damage; Accident Reporting.
                    </strong>
                  </u>
                  &nbsp;Renter shall be solely responsible to Joulez for any
                  loss or damage to the EV from any cause whatsoever occurring
                  after delivery of the EV to Renter and before possession of
                  the EV is returned to Joulez, except for any loss or damage
                  directly attributable to the gross negligence or willful
                  misconduct of Joulez or its representatives. Renter has the
                  right the inspect the EV to assess any claimed damages. Renter
                  understands and agrees that if they do not have adequate
                  insurance coverage, Renter shall be responsible for all loss
                  and damages, including, but not limited to that actual
                  damages, diminution of value, and loss of use. In the event of
                  any accident involving the EV, Renter shall ensure that the
                  ensure the following (a) obtain the vehicle registration
                  numbers of the vehicles involved, the names, addresses and
                  identification card numbers of the parties involved and those
                  of the witnesses to the accident, if any, shall be obtained;
                  (b) no fault or liability shall be admitted on the part of the
                  Renter or any person using the EV; and (c) the EV shall not be
                  abandoned without ensuring adequate provision has been made
                  for the safeguarding and securing of the EV. Joulez shall be
                  notified of the accident within 24 hours of the accident
                  occurring, and Renter shall assist Joulez in providing all the
                  necessary information pertaining to the accident to the
                  relevant insurer (if required). Renter shall be required to
                  make a police report and forward a copy of the accident report
                  to Joulez as soon as possible if the accident involves: a
                  fatality; damage to government property; a foreign vehicle; a
                  pedestrian or cyclist; a hit-and-run case; injury (where at
                  least one person involved in the accident was taken to
                  hospital from the accident scene (whether by an ambulance or
                  otherwise) or any party involved in the accident was injured;
                  or theft, any other criminal act and/or a total loss of the
                  EV. Joulez reserves the right to report any EV related
                  incidents to relevant authorities, including law enforcement.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Interior Damage:</strong>
                  </u>
                  &nbsp;Renter shall be responsible for any Interior Damage to
                  the EV during to the Rental Period. “Interior Damage” shall
                  mean any damage or destruction to the interior of the vehicle
                  or attached interior accessories provided as part of the
                  rental, where said damage requires replacement or physical
                  repair work of such interior components in excess of $100.
                  Interior damage is assumed to be the result of a non-collision
                  accident and would fall under the categories of excessive use,
                  negligence or accidental interior damage beyond normal wear
                  and tear. For the avoidance of doubt, Interior Damage is not
                  covered by insurance or the Joulez Protection Plan.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Smoking:</strong>
                  </u>
                  &nbsp;Smoking in all forms (cigars, cigarettes, and marijuana)
                  is STRICTLY PROHIBITED in all Joulez vehicles. A $400 cleaning
                  fee will be charged to Renter’s Account if Joulez determines
                  in its reasonable discretion that smoking has taken place
                  inside the EV. Any claims of smoking may be substantiated by
                  video, photographic, physical evidence, or electronic smell
                  detection technology to indicate the presence of smells that
                  occurred while the EV was in the possession of Renter.
                </p>
              </li>

              <li className="mb-2">
                <div>
                  <u>
                    <strong className="fontcolorFFF">Cleaning Fee:</strong>
                  </u>
                  &nbsp;All vehicles should be returned by Renter in the same
                  condition they were delivered to Renter both physically and
                  with minimal odor change to the vehicle. Any residual odors
                  from food, pet, body or other noxious odors that are unable to
                  be removed through light vacuuming and surface cleaning will
                  be assessed an excess cleaning fee and/or odor violation fee.
                  The cleaning fee shall be assessed if upon return of the EV,
                  Joulez encounters any of the following:
                </div>
                <div className="mb-1">
                  <div>(a) Biowaste, bodily fluids, spills or waste.</div>
                  <div>
                    (b) Significant amounts of animal hair (regardless of
                    whether the animal is a registered service animal).
                  </div>
                  <div>
                    (c) Spills or waste that requires cleaning inside of vents
                    or between the door panel and window.
                  </div>
                  <div>
                    (d) Major stains or residue that covers an area of the
                    vehicle’s interior and would require steam cleaning or a
                    full detail, larger than the size of a US Quarter Dollar
                    coin.
                  </div>
                  <div>
                    (e) An extreme amount of caked on mud, dirt, sand, or
                    insects that requires professional-level exterior detailing.
                  </div>
                  <div>
                    (f) More litter or trash than would fit into a 8” x 10” x
                    4.5” bag (standard size of a Starbucks carryout bag for
                    reference).
                  </div>
                </div>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">
                      Pets and Service Dogs:
                    </strong>
                  </u>
                  &nbsp;Pets may be transported in the EV, subject to payment of
                  a pet fee of <strong>$100/Trip</strong> or{" "}
                  <strong>$25/Day</strong>, whichever is less, plus any
                  applicable local and state taxes. Service dogs are allowed in
                  the EV without a pet fee, provided that it is readily apparent
                  that a dog is a service animal. Joulez may ask under state law
                  and the federal ADA, (a) if the animal is required because of
                  a disability, and (b) what work the animal has been trained to
                  perform. All non-service animals must be crated and have a mat
                  or towel laid down between the seat and the crate, or must be
                  in a space where a mat, towel or other seat cushion is in
                  place to avoid any interior damage. Any interior damage caused
                  to the EV by an animal will result in a damage claim from
                  Joulez for the cost of repairs to the EV.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Child Seats:</strong>
                  </u>
                  &nbsp;Child safety seats are provided upon request for an
                  additional per-day fee via Renter’s account. Any excessive
                  cleaning fees or damage to a child safety seat will be billed
                  to the Renter for up to a total of $200. Joulez shall not be
                  held liable for any manufacturer defects or improper usage of
                  the child safety seats in the EV.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">
                      Parking Passes & Key Cards:
                    </strong>
                  </u>
                  &nbsp;Joulez vehicles are parked in garages that require a
                  physical parking pass to enter and exit the garage. Renter is
                  responsible for returning the parking pass to Joulez upon
                  completion of the Rental Period. If the parking pass is not
                  returned with the EV, there is a <strong>$75</strong> parking
                  pass fee. Teslas and Rivians have a key card that may come
                  with the vehicle, unless a mobile phone key is used. Any Tesla
                  or Rivian key card that is lost or damaged will incur a{" "}
                  <strong>$100</strong> lost key card fee to cover the cost of
                  replacement and reprogramming. All other keys that are lost or
                  damaged will incur a <strong>$250</strong> lost key fee to
                  cover the cost of replacement and reprogramming.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">
                      Third-Party Adapters:
                    </strong>
                  </u>
                  &nbsp;In order to avoid risk of serious injury and property
                  damage, users of Tesla charging stations may only use adapters
                  sold or provided by Tesla or by other automakers in the United
                  States. Renter’s use of any other adapter with Tesla’s
                  charging stations is strictly prohibited. Renter shall be
                  responsible from any damages to the EV derived from the use of
                  any third-party adapters.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Indemnity:</strong>
                  </u>
                  &nbsp;Renter shall fully indemnify, defend, and hold harmless
                  Joulez, its officers, shareholders, directors, employees,
                  subsidiaries and affiliates, against any judgments, fines,
                  losses, claims, damages, liabilities, costs or expenses
                  (including reasonable attorney’s fees) arising directly or
                  indirectly from Renter’s use of EV during the Rental Period,
                  including but not limited to,
                </p>
                <b className="fontColorFFF">Falsification of Insurance Coverage</b>
                <p>
                  (a) In the event that any Renter is found to have provided
                  false, misleading, or otherwise fraudulent information
                  regarding their insurance or liability coverage, including
                  presenting documentation or representations of coverage that
                  are invalid, expired, inapplicable, or otherwise not legally
                  enforceable, such Renter shall assume full legal and financial
                  responsibility for any and all claims, damages, losses,
                  injuries (including personal injury or death), or liabilities
                  arising out of or in connection with the use or possession of
                  the EV during the Rental Period. This responsibility shall
                  include, without limitation, all repair or replacement costs
                  for damage to the EV, all third-party claims for bodily injury
                  or property damage, and all associated legal and
                  administrative costs, regardless of fault. Renter further
                  agrees to indemnify, defend, and hold harmless Joulez, Inc.
                  and its affiliates, employees, and agents against any such
                  claims to the fullest extent permitted by law. This clause
                  shall survive the termination or expiration of this Agreement.
                  (b) damage to the EV, (c) damage or destruction to property,
                  (d) bodily injury, death, or impairment to any person. This
                  provision survives the termination of this Agreement. Renter
                  agrees to present a claim to their insurance carrier for all
                  such expenses. If Renter has no insurance to cover such events
                  or losses, Renter agrees to pay Joulez or its affiliate(s) for
                  such losses. Renter agrees to further indemnify and hold
                  Joulez or its affiliate(s) harmless to the extent permitted by
                  law from attorney fees that are incurred or may be incurred in
                  defending or prosecuting any claims, actions, causes of
                  action, lawsuits or controversies that are brought by or
                  against Joulez or its affiliate(s) arising from the Renter’s
                  use, operation or possession of the EV.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Warranties:</strong>
                  </u>
                  &nbsp;Joulez represents that to the best of his knowledge and
                  belief that the EV is in good condition and safe for ordinary
                  operation of the EV. Renter represents that Renter shall not
                  (a) operate the EV in violation of any laws or for any illicit
                  purpose; (b) use the EV to push or tow another EV or any other
                  vehicle; (c) use the EV for any race or competition; or (d)
                  operate the EV in a negligent manner. Renter represents that
                  Renter is legally entitled to operate a motor EV under the
                  laws of the applicable jurisdiction where the EV will be
                  operated during the Rental Period. Joulez and Renter both
                  acknowledge that each has examined the EV prior to the rental,
                  and that it is in good condition.{" "}
                  <strong>
                    All EVs will be provided with at least 80% of full charge.
                    Joulez does not warrant that the EV will be provided to
                    Renter with 100% charge
                  </strong>
                  . JOULEZ MAKES NO WARRANTY, EXPRESS OR IMPLIED, OR OF
                  SATISFACTORY QUALITY, FITNESS FOR A PARTICULAR PURPOSE,
                  QUALITY, COMPATIBILITY, COURSE OF DEALING, COURSE OF
                  PERFORMANCE, USAGE OF TRADE OR OTHERWISE, AND EXPRESSLY
                  EXCLUDES AND DISCLAIMS ALL WARRANTIES AND REPRESENTATIONS OF
                  ANY KIND, INCLUDING ANY WARRANTIES OF MERCHANTABILITY AND/OR
                  FITNESS FOR A PARTICULAR PURPOSE.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">
                      Suspension of Services; Termination:
                    </strong>
                  </u>
                  &nbsp;Joulez, in its sole discretion, may suspend Renter’s
                  access to the EV in the event of a breach of any of the terms
                  of this Agreement, including, but not limited to, (a) restrict
                  or block access to charging services for vehicle, (b) remove
                  access to the EV via mobile application, (c) disabling of the
                  EV key or key card, (d) reduce the maximum speed a vehicle can
                  be driven. Additionally, Joulez reserves the right to
                  terminate this Agreement upon failure by Renter to comply with
                  the provisions of this Agreement, including, but not limited
                  to nonpayment of fees, misuse of the EV, or violation of
                  applicable law. Renter’s obligations under this Agreement,
                  including Renter’s obligations to return the EV and pay
                  applicable fees, shall survive termination of the Agreement.
                  Upon termination, Joulez may repossess of the EV, without
                  demand or notice, wherever it may be located, without any
                  court order or other process of law
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">
                      Limitation of Liability:
                    </strong>
                  </u>
                  &nbsp;TO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE LAW, IN
                  NO EVENT SHALL JOULEZ BE LIABLE TO RENTER UNDER ANY LEGAL
                  THEORY, WHETHER IN AN ACTION BASED ON A CONTRACT, TORT
                  (INCLUDING NEGLIGENCE), STRICT LIABILITY, OR OTHERWISE
                  PROVIDED BY STATUTE OR LAW, FOR ANY INCIDENTAL, SPECIAL,
                  EXEMPLARY, CONSEQUENTIAL, OR STATUTORY DAMAGES, OR ANY DAMAGES
                  RESULTING FROM LOST PROFITS, INTERRUPTION OF BUSINESS, OR LOSS
                  OF GOODWILL, EVEN IF JOULEZ HAD BEEN ADVISED OF THE
                  POSSIBILITY OF SUCH DAMAGES. JOULEZ LIABILITY RELATED TO OR
                  ARISING OUT OF THIS AGREEMENT SHALL NOT EXCEED THE FEES
                  ACTUALLY PAID BY RENTER TO JOULEZ UNDER THIS AGREEMENT.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Arbitration:</strong>
                  </u>
                  &nbsp;Before asserting a claim in any proceeding whatsoever,
                  the Parties agree that each shall give the other Party written
                  notice thirty (30) days in advance and make a reasonable, good
                  faith effort to resolve the claim. In the event that the
                  Parties cannot amicably resolve the claim, the Parties agree
                  to submit the claim to arbitration. The arbitration proceeding
                  shall be conducted in New York, New York, in accordance with
                  the rules of the American Arbitration Association then in
                  effect with one arbitrator to be selected by mutual agreement
                  of the Parties. If the Parties cannot agree on an arbitrator,
                  then the American Arbitration Association shall select an
                  arbitrator from the National Panel of Arbitrators. The laws of
                  the State of New York shall apply to the arbitration
                  proceedings. The Parties agree that the arbitrator cannot
                  award punitive damages to either Party and agree to be bound
                  by the arbitrator’s findings. Judgment upon the award rendered
                  by the arbitrator may be entered in any court having
                  jurisdiction.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Privacy Policy:</strong>
                  </u>
                  &nbsp;All information provided by Renter to Joulez under this
                  Agreement will be subject to the Joulez Privacy Policy (
                  <a
                    className="fontColorCE1"
                    href="https://drivejoulez.com/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://drivejoulez.com/privacy-policy
                  </a>
                  ).
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Governing Law:</strong>
                  </u>
                  &nbsp;If any dispute arising from this Agreement is filed in
                  any court, the laws of the State of New York shall govern this
                  Agreement without regard to any conflict of law principles. No
                  action, arising out of the transactions under this Agreement
                  may be brought by either Party more than one year after the
                  cause of action has accrued.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Notices:</strong>
                  </u>
                  &nbsp;Any notice or other communication required or permitted
                  hereunder shall be given in writing to the other Party at the
                  address provided by either Party to the other in writing.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">
                      Severability & Waiver:
                    </strong>
                  </u>
                  &nbsp;In the event that any portion of this Agreement is held
                  to be unenforceable, the unenforceable portion shall be
                  amended to reflect, to the greatest extent permitted under
                  applicable law, the original intent of the Parties, and the
                  remainder of the provisions shall remain in full force and
                  effect. The waiver by either Party of a breach of any
                  provision of the Agreement shall not operate or be construed
                  as a waiver of any subsequent breach and any waiver must be in
                  writing and signed by the Parties hereto.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Interpretation:</strong>
                  </u>
                  &nbsp;Headings are inserted for the convenience of the Parties
                  only and are not to be considered when interpreting this
                  Agreement. Words in the singular mean and include the plural
                  and vice versa. Words in the masculine means and include the
                  feminine and vice versa.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Survival:</strong>
                  </u>
                  &nbsp;All contractual provisions of this Agreement that
                  should, by their nature, survive the termination of this
                  Agreement, shall so survive.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">
                      Successors and Assigns:
                    </strong>
                  </u>
                  &nbsp;This Agreement may not be assigned without the prior
                  written consent of Joulez. The rights and obligations created
                  by this Agreement shall be binding upon and inure to the
                  benefit of the Parties, their successors and assigns.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Entire Agreement:</strong>
                  </u>
                  &nbsp;This Agreement and the Terms constitute the entire
                  agreement between the Parties and supersedes any prior
                  understanding or representation of any kind preceding the date
                  of this Agreement. In the event of a conflict between this
                  Agreement and the Terms, the provisions in this Agreement
                  shall govern. There are no other promises, conditions,
                  understandings or other agreements, whether oral or written,
                  relating to the subject matter of this Agreement. Unless
                  otherwise provided herein, this Agreement may only be modified
                  in writing and must be signed by both Parties.
                </p>
              </li>
              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Counterparts:</strong>
                  </u>
                  &nbsp;This Agreement and any documents pursuant hereto may be
                  separately executed by the Parties in two or more
                  counterparts, and by facsimile, PDF, or similar means of
                  electronic delivery, and all such counterparts shall be deemed
                  an original, but all of which together shall constitute one
                  and the same instrument and will be binding on the Parties as
                  if they had originally signed one copy of the Agreement.
                </p>
              </li>

              <li>
                <p>
                  <u>
                    <strong className="fontcolorFFF">Collections:</strong>
                  </u>
                  &nbsp;The renter understands that if there is an unpaid
                  balance to Joulez, Inc. and satisfactory payment arrangements
                  are not made, the account may be placed with an external
                  collection agency. The renter will be responsible for
                  reimbursing any fees charged by the collection agency, which
                  may be based on a percentage of the debt, not exceeding 35%,
                  as well as all costs and expenses, including reasonable
                  collection and attorney’s fees incurred during collection
                  efforts.
                  <p className="mt-2">
                    &nbsp;In order for Joulez, Inc. or their designated external
                    collection agency to service the renter's account, and where
                    not prohibited by applicable law, the renter agrees that
                    Joulez, Inc. and the designated external collection agency
                    are authorized to (i) contact the renter by telephone at the
                    telephone number(s) provided, including wireless telephone
                    numbers, which could result in charges to the renter, (ii)
                    contact the renter by sending text messages (message and
                    data rates may apply) or emails, using any email address
                    provided, and (iii) methods of contact may include using
                    pre-recorded/artificial voice messages and/or the use of an
                    automatic dialing device, as applicable. Furthermore, the
                    renter consents to the designated external collection agency
                    sharing personal contact and account-related information
                    with third-party vendors to communicate account-related
                    information via telephone, text, email, and mail
                    notification.
                  </p>
                </p>
              </li>
            </ol>
            <p>
              <strong className="fontcolorFFF"> IN WITNESS WHEREOF</strong>, the
              Parties have signed this Agreement intending to be legally bound
              by the provisions set forth herein and the Terms and Conditions in{" "}
              <span className="text-decoration-underline">Exhibit A</span>.
            </p>
          </div>
          <div></div>
          <div className="col-md-12 terms-section">
            <p>&copy; {currentYear} Joulez Inc., All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RentalAgreement;
